<template>
  <div class="contact">
    <page-hero :title="title" :subtitle="subtitle" :cta="false" />
    <div class="flex flex-col sm:flex-row flex-wrap my-8">
      <div
        class="w-full sm:w-1/2 md:w-1/2 flex flex-col items-center justify-center h-48 md:h-64 border-grey-lightest border-r border-b hover:shadow-md hover:border-0 bg-white hover:transform-scale-subtle transition-normal hover:show-child"
      >
        <a href="tel:+16479303368">
          <div class="w-12 h-12" alt>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path
                d="M20 18.35V19a1 1 0 0 1-1 1h-2A17 17 0 0 1 0 3V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4c0 .56-.31 1.31-.7 1.7L3.16 8.84c1.52 3.6 4.4 6.48 8 8l2.12-2.12c.4-.4 1.15-.71 1.7-.71H19a1 1 0 0 1 .99 1v3.35z"
              />
            </svg>
          </div>
          <h3 class="mt-4 mb-1">Phone</h3>
          <p class="mt-4 text-center text-grey-dark leading-normal hover:block">
            (647) 930-3368
          </p>
        </a>
      </div>
      <div
        class="w-full sm:w-1/2 md:w-1/2 flex flex-col items-center justify-center h-48 md:h-64 p-8 border-grey-lightest border-r border-b hover:shadow-md hover:border-0 bg-white hover:transform-scale-subtle transition-normal hover:show-child"
      >
        <a href="mailto:reshma_1698@hotmail.com">
          <div class="w-12 h-12" alt>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path
                d="M18 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h16zm-4.37 9.1L20 16v-2l-5.12-3.9L20 6V4l-10 8L0 4v2l5.12 4.1L0 14v2l6.37-4.9L10 14l3.63-2.9z"
              />
            </svg>
          </div>
          <h3 class="mt-4 mb-1">Email</h3>
          <p class="mt-4 text-center text-grey-dark leading-normal hover:block">
            experiawebdev@gmail.com
          </p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import PageHero from "@/components/PageHero";

export default {
  name: "contact",
  components: {
    PageHero
  },
  data() {
    return {
      title: "Contact Us",
      subtitle: `We would love to work with you on a project. Reach out to us by phone, email, or through the form below to initiate a discussion.`
    };
  }
};
</script>
